/** A link that points at source code (GitHub) rather than a hosted/live site. */
export function isRepoLink(link?: string): boolean {
  return !!link && /github\.com/i.test(link);
}
